import { render } from "./IconTransferMoney.vue?vue&type=template&id=aeb01332"
import script from "./IconTransferMoney.vue?vue&type=script&lang=js"
export * from "./IconTransferMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconTransferMoney.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aeb01332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aeb01332', __exports__)) {
    api.reload('aeb01332', __exports__)
  }
  
  module.hot.accept("./IconTransferMoney.vue?vue&type=template&id=aeb01332", () => {
    api.rerender('aeb01332', render)
  })

}


export default __exports__